import React from 'react';
import { PRICING } from '../pricing';
import QuizIcon from '@mui/icons-material/Quiz';
import PsychologyIcon from '@mui/icons-material/Psychology';
import TipsAndUpdatesIcon from '@mui/icons-material/TipsAndUpdates';

export const aiFundamentals = {
    title: "AI Fundamentals",
    icon: <PsychologyIcon sx={{ fontSize: 40, color: '#8b5cf6' }} />,
    description: "Master the foundations of Machine Learning and Neural Networks.",
    price: PRICING.aiFundamentals.price,
    mrp: PRICING.aiFundamentals.mrp,
    topics: [
      {
        id: "ai_intro",
        title: "Intro to AI",
        desc: "History, types of AI, and future landscape.",
        badge: "Core",
        fileUrl: "/documents/ai/ai_intro.md",
        icon: <TipsAndUpdatesIcon />,
        group: "AI Basics",
        problems: []
      },
      {
        id: "ai_fundamentals_quizzes",
        title: "AI Fundamentals Quizzes",
        desc: "Consolidated assessment for AI basics.",
        badge: "Quiz",
        icon: <QuizIcon />,
        group: "Final Assessment",
        problems: [
          { id: "quiz_ai_intro", title: "Intro to AI Quiz", badge: "Quiz", fileUrl: "/documents/quizzes/quiz_ai_intro.md" }
        ]
      }
    ]
  };
